// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8281":"css/admin-app.6789","8634":"css/app.6789"}[chunkId] + ".css";
};